export default "__VITE_ASSET__bd529079__"